import type { TValidRoutes } from '@/tanstackSetup'

export const ROUTER_HISTORY_LOCAL_STORAGE_KEY = 'routerHistory'
export const ROUTER_HISTORY_INVALID_ROUTES: TValidRoutes[] = []
export const ROUTER_HISTORY_MAX_LENGTH = 10
